import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=f87272d4&scoped=true&lang=pug&"
import script from "./Timeline.vue?vue&type=script&lang=ts&"
export * from "./Timeline.vue?vue&type=script&lang=ts&"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=f87272d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87272d4",
  null
  
)

export default component.exports